module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-holiday-work-schedules@2x-444c5e42cbc4fb3de71e582452d38202.png";